<template>
  <div class="apple-ui-state" :class="{ 'is-error': Boolean(error), 'is-loading': loading, 'is-empty': !error && !loading && !count }" :aria-busy="String(loading)">
    <p v-if="error" class="apple-ui-state-message" role="alert" aria-live="assertive"><span>{{ error }}</span><AppleButton variant="plain" :disabled="loading" @click="$emit('retry')">重试</AppleButton></p>
    <p v-else-if="loading" class="apple-ui-state-message" role="status" aria-live="polite">{{ loadingText }}</p>
    <p v-else-if="!count" class="apple-ui-state-message" role="status" aria-live="polite">{{ emptyText }}</p>
    <AppleButton v-if="more && !error" class="apple-ui-state-more" variant="subtle" :disabled="loading" @click="$emit('more')">{{ loading ? loadingText : '加载更多' }}</AppleButton>
  </div>
</template>
<script>
import AppleButton from './AppleButton.vue';
export default {
  name: 'AppleState', components: { AppleButton },
  props: { error: { type: String, default: '' }, loading: Boolean, count: { type: Number, default: 0 }, more: Boolean, emptyText: { type: String, default: '来源暂未返回此分类内容。' }, loadingText: { type: String, default: '正在加载…' } },
};
</script>
<style scoped>
.apple-ui-state { display:flex; flex-direction:column; align-items:center; min-width:0; color:var(--apple-ui-muted, var(--color-secondary)); font-size:13px; text-align:center; }
.apple-ui-state-message { display:flex; flex-wrap:wrap; align-items:center; justify-content:center; gap:8px; max-width:64ch; margin:20px 0; line-height:1.6; overflow-wrap:anywhere; }
.apple-ui-state.is-error .apple-ui-state-message { color:var(--color-text); }
.apple-ui-state-more { margin:0 0 20px; }
</style>
